import React from "react";

const ForbesFeature = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="glass-dark rounded-[32px] border border-white/10 p-8 md:p-12">
          <div className="grid md:grid-cols-[1fr_auto] gap-8 items-center">

            <div>
              <div className="chip-dark inline-flex mb-5">
                FEATURED IN FORBES INDIA
              </div>

              <h2 className="font-display text-3xl md:text-5xl font-black text-white leading-tight">
                Asim featured among the changemakers
                powering India’s economic growth
              </h2>

              <p className="mt-5 text-white/60 text-base md:text-lg max-w-2xl leading-relaxed">
                Asim has been featured by Forbes India in its
                Changemakers series, highlighting individuals
                contributing to India’s evolving entrepreneurial
                and economic landscape.
              </p>

              <a
                href="https://www.forbesindia.com/article/upfront/brand-connect/changemakers-powering-indias-economic-growth/2997385/1"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary inline-flex mt-7"
              >
                Read the Forbes India Feature →
              </a>
            </div>

            <div className="w-32 h-32 md:w-40 md:h-40 rounded-3xl bg-white flex items-center justify-center">
              <span className="text-black font-serif font-bold text-2xl md:text-3xl">
                Forbes
              </span>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ForbesFeature;